import { EmployerOptions } from '../EmployerOptions';
import { Payment } from '../../objects/Payment';

/**
 * @typedef { import('../PaymentLock').PaymentLock } PaymentLock
 * @typedef { import('../PayslipModel').PayslipModel } PayslipModel
 * @typedef { import('../PaymentModel').PaymentModel } PaymentModel
*/

export class PaymentEditorModel {
    /**
     * @param {PayslipModel} payslipModel
     * @param {Payment} payment
     */
    constructor(payslipModel, payment) {
        this.payslipModel = payslipModel;
        this.payment = payment;

        /** @type {string}*/
        this.selectedEmployer = null;
        /** @type {EmployerOptions[]} */
        this._employerOptions = null;
        /** @type {PaymentModel} */
        this.original = null;
    }

    get enableLostIncome() {
        return this.payslipModel.enableLostIncome;
    }

    get isNew() {
        return this.original == null;
    }

    get isPersisted() {
        return !!this.payment.Id;
    }

    get employerOptions() {
        if (this._employerOptions == null) {
            this._employerOptions = EmployerOptions.fromAttendance(this.payslipModel.attendance);
        }
        return this._employerOptions;
    }

    apply() {
        let pm = this.original;

        if (pm == null) {
            pm = this.payslipModel.addPayment(this.payment);
        } else {
            this.payslipModel.updatePayment(pm, this.payment);
        }

        pm.selectedEmployer = this.selectedEmployer;
    }

    remove() {
        if (this.original) {
            this.payslipModel.removePayment(this.original);
        }
    }

    /**
     * @param {PaymentLock} paymentLock
     * @param {PayslipModel} payslipModel
     */
    static createNew(paymentLock, payslipModel) {
        if (paymentLock == null || paymentLock.isLocked) return null;

        let model = new PaymentEditorModel(payslipModel, new Payment());
        
        paymentLock.lockPayslip(payslipModel);

        return model;
    }

    /**
     * @param {PaymentLock} paymentLock
     * @param {PaymentModel} paymentModel
     */
    static createExisting(paymentLock, paymentModel) {
        if (paymentLock == null || paymentLock.isLocked) return null;

        let payment = paymentModel.payment.clone();
        let model = new PaymentEditorModel(paymentModel.group.payslipModel, payment);
        model.selectedEmployer = paymentModel.selectedEmployer;
        model.original = paymentModel;

        paymentLock.lockGroup(paymentModel.group);

        return model;
    }
}
